import { elderServiceEventOptions } from '@silvergatedelivery/constants';
import elderDeactivationReason from '@silvergatedelivery/constants/src/elderDeactivationReason';

export const getElderServiceEvents = (inElderServiceEvents = [], elders = [], showElderName = false) => {
  return inElderServiceEvents.map((item) => {
    const {
      color: defaultColor,
      label,
    } = elderServiceEventOptions.find((option) => option.id === item.type) || {};

    let description = item.description;
    let color = defaultColor;
    if (item.type === 'reminder') {
      if (item.status === '已停用') {
        description = `${item.description}（已關閉）`;
        color = '#9e9e9e';
      }
    } else if (item.type === 'serviceStop') {
      const deactivationReason = elderDeactivationReason.find((reason) => reason.value === item.description);
      description = deactivationReason ? deactivationReason.label : item.description;
    }

    return {
      title: showElderName ? `${elders.find((elder) => elder.id === item.elderId)?.name} ${label}` : label,
      start: item.startedAt,
      end: item.endedAt,
      allDay: true,
      backgroundColor: color,
      extendedProps: {
        type: 'elderService',
        data: item,
        description,
      },
    };
  });
};

export const elderServiceEventConfig = {
  leave: {
    title: '送餐對象請假',
    dateLabel: '請假日期',
    reasonLabel: '請假原因',
    noteLabel: '請假備註',
    reasonPlaceholder: '請輸入請假原因...',
    notePlaceholder: '請輸入請假備註...',
    cancellationReason: 'elderLeave',
    defaultNote: '請假',
    eventType: 'leave',
  },
  medical: {
    title: '送餐對象醫療事件',
    dateLabel: '醫療日期',
    reasonLabel: '醫療原因',
    noteLabel: '醫療備註',
    reasonPlaceholder: '請輸入醫療原因...',
    notePlaceholder: '請輸入醫療備註...',
    cancellationReason: 'elderSick',
    defaultNote: '醫療',
    eventType: 'medical',
  },
  serviceStop: {
    title: '送餐對象停止服務',
    dateLabel: '停止服務日期',
    reasonLabel: '停止服務原因',
    noteLabel: '備註',
    reasonPlaceholder: '請輸入停止服務原因...',
    notePlaceholder: '請輸入備註...',
    cancellationReason: 'serviceStop',
    defaultNote: '停止服務',
    eventType: 'serviceStop',
  },
};
